import { useContext } from 'react';
import { defineMessages } from '@alltrails/shared/react-intl';
import { bool } from 'prop-types';
import Button from '@alltrails/shared/denali/components/Button';

import LearnMore from '../LearnMore';
import { PrintContext } from '../../printContext';
import { DECIMAL, DMS, UTM, NONE, GRID_LABELS } from '../../constants';
import useFormatMessage from '@alltrails/shared/hooks/useFormatMessage';

const GRID_STRINGS = defineMessages({
  GRID: { defaultMessage: 'Grid' },
  CONTENT: {
    defaultMessage:
      'Decimal degrees (DD) express latitude and longitude geographic coordinates as decimal fractions of a degree. DD are used in many geographic information systems (GIS), web mapping applications such as OpenStreetMap, and GPS devices.\n\nGPS mapping programs and units default to DMS. It treats the earth as a sphere and covers the entire earth with a single coordinate system.\n\nUTM is a simplified system for land use. It breaks the surface of the earth into a large number of small sections and treats each one as a plane using meters as the coordinate units.'
  }
});

const Grid = ({ isMobileWidth }) => {
  const {
    formattedDefaultMessages: { GRID, CONTENT }
  } = useFormatMessage(GRID_STRINGS);
  const { grid, setGrid } = useContext(PrintContext);

  return (
    <div className="buttonRow">
      {[DECIMAL, DMS, UTM, NONE].map(g => (
        <Button
          text={GRID_LABELS[g]}
          className="settingsButton"
          key={`grid-${g}`}
          onClick={() => setGrid(g)}
          testId={GRID_LABELS[g]}
          variant={grid === g ? 'primary' : 'default'}
        />
      ))}
      <LearnMore title={GRID} content={CONTENT} grid isMobileWidth={isMobileWidth} />
    </div>
  );
};

Grid.propTypes = {
  isMobileWidth: bool
};

Grid.defaultProps = {
  isMobileWidth: false
};

export { Grid };
